import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
// import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { useSelector } from "react-redux";
// import { get_vendor_list } from "../../redux/vendorSlice";
import { useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_quotation_list } from "../../redux/quotationSlice";
import { get_purchase_order_list } from "../../redux/purchaseOrderSlice";

const Quotation = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const {purchase_order_list, total_quotation_count  } = useSelector(
    (state) => state.purchaseOrder
  );

  useEffect(() => {
    store.dispatch(get_purchase_order_list({ page: page, rows: rows }));
  }, []);
  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_purchase_order_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_quotation_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_quotation_count || setpage(page + 1);
    rows * page >= total_quotation_count ||
      store.dispatch(get_purchase_order_list({ page: page + 1, rows: rows }));
  };
  return (
    <>
<Card
  bg="#fff"
  paddingInline={5}
  paddingBlock={2}
  display="flex"
  flexDirection={["column", "column", "row"]}
  alignItems={["stretch", "stretch", "center"]}
  gap={3}
  flexWrap="wrap"
>
  <Heading fontSize="xl" flexShrink={0}>
    Purchase Order List
  </Heading>

  <Spacer display={["none", "none", "block"]} />

  <Flex
    direction={["column", "row"]}
    gap={2}
    alignItems="center"
    justifyContent={["flex-start", "flex-end"]}
    flex="1"
    flexWrap="wrap"
  >
    <Select
      placeholder="Rows"
      size="md"
      w={["100%", "100px"]}
      value={rows}
      onChange={(e) => {
        store.dispatch(get_purchase_order_list({ page, rows: e.target.value }));
        setRows(e.target.value);
      }}
    >
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </Select>

    <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "auto"]} maxW="sm">
      <Input placeholder="Search..." />
      <InputRightElement>
        <FiSearch />
      </InputRightElement>
    </InputGroup>
  </Flex>
</Card>



      <SimpleGrid minChildWidth="xs" spacing="10px">
      {purchase_order_list?.map((el, i) => (
  <Card
    key={el.id}
    paddingInline={5}
    paddingBlock={2}
    cursor="pointer"
    onClick={() =>
      navigate("/purchase-order/purchaseorder-detail", { state: el.id })
    }
  >
    {/* Quotation Serial Number */}
    <DisplayData
      fs="16px"
      v_color="#169e49"
      fw="bold"
      value={el.customer_name || "NA"}
    />

    {/* Date */}
    <DisplayData title="PO. No." value={el.ponum || "NA"} />
    <DisplayData title="Quotation No." value={el.quotation_no || "NA"} />
    <DisplayData title="PO Date" value={el.createdat || "NA"} />
    <DisplayData title="Quotation Date." value={el.quotation_date || "NA"} />
    <DisplayData title="Date & Time" value={el.podate || "NA"} />
    <DisplayData 
  title="Total Amount" 
  value={
    el.products && el.products.length > 0
      ? `₹${el.products.reduce((total, product) => {
          return total + (parseFloat(product.qty || 0) * parseFloat(product.price || 0));
        }, 0).toFixed(2)}`
      : "NA"
  } 
/>

    {/* Status */}

  </Card>
))}

      </SimpleGrid>
      <Card
        alignItems={"center"}
        alignSelf={"end"}
        gap={3}
        flexDirection={"row"}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />

        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_quotation_count
              ? total_quotation_count
              : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_quotation_count}</Text>
        </Flex>

        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_quotation_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
    </>
  );
};

export default Quotation;

